import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

// Audits regular actions

export interface LowAudit {
  _id: mongoose.Schema.Types.ObjectId;
  userId: string;
  userEmail: string;
  customerId: string;
  itsmCustomerId: string;
  event: string;
  time1: Date;
  time2?: Date;
  payload1: string;
  payload2?: string;
}

export const LowAuditSchema = new mongoose.Schema<LowAudit>({
  userId: String,
  customerId: String,
  userEmail: String,
  itsmCustomerId: String,
  event: String,
  time1: Date,
  time2: Date,
  payload1: String,
  payload2: String,
});

const props: (keyof LowAudit)[] = [
  "userId",
  "userEmail",
  "customerId",
  "itsmCustomerId",
  "event",
  "time1",
  "time2",
  "payload1",
  "payload2",
];

export const searchProps: (keyof LowAudit)[] = [
  "userEmail",
];

export const filterProps: (keyof LowAudit)[] = [
  "customerId",
  "event",
];

export const dateProps: (keyof LowAudit)[] = [
  "time1",
  "time2",
];

export function matches(a: LowAudit, b: LowAudit): boolean {
  return match(a, b, props);
}

export const lowAuditUtils = {
  props,
  searchProps,
  filterProps,
  dateProps,
  matches,
};
